'use client'

import { usePathname } from 'next/navigation'
import { ProductCardAnimationProvider } from 'product-card/context/ProductCardAnimationContext'
import { ProductCardAnimation } from 'product-card/types'
import { useMemo } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { isSessionStorageAvailable } from 'utils/webStorage/sessionStorage'

import { useInspirationalProvider } from '../../context/InspirationalProvider/useInspirationalProvider'

type Props = {
	children: React.ReactNode
}

export const AddProductCardAnimation = ({ children }: Props) => {
	const pathname = usePathname()
	const { referrerInfo } = useInspirationalProvider()
	const { isLargeOrGreater } = useResponsive()

	const shouldRenderSlideshow = useMemo(() => {
		const isServer = !isSessionStorageAvailable()
		// I don't come from a PDP nor I am refreshing the page
		const isFirstVisit =
			!referrerInfo.product && referrerInfo.pathname !== pathname

		return !isServer && isFirstVisit && !isLargeOrGreater
	}, [isLargeOrGreater, pathname, referrerInfo.pathname, referrerInfo.product])

	const animation = shouldRenderSlideshow
		? ProductCardAnimation.Slideshow
		: ProductCardAnimation.FadeIn

	return (
		<ProductCardAnimationProvider animation={animation}>
			{children}
		</ProductCardAnimationProvider>
	)
}
